<template>
  <div
    class="resume-list"
    :class="{
      'without-padding':
        metaData &&
        metaData.subpanels &&
        metaData.subpanels.panelColumn &&
        metaData.subpanels.panelColumn.length
    }"
  >
    <Subpanel
      v-if="
        metaData &&
        metaData.subpanels &&
        metaData.subpanels.panelColumn &&
        metaData.subpanels.panelColumn.length
      "
      :tabs="metaData.subpanels.panelColumn"
      module="HRPAC_CANDIDATE_RESUME"
      class="resume-list__subpanel"
    >
    </Subpanel>

    <Alert
      v-else
      text="Резюме еще не были добавлены. Вы можете добавить их с помощью кнопки «Редактировать»"
      class="resume-list__alert"
    />
  </div>
</template>

<script>
// import { store } from '@/store';
import { mixin } from '@/utils/mixins';
import Alert from 'Elements/Alert/Alert';

export default {
  mixins: [mixin],
  props: {
    metaData: {
      type: Object
    }
  },
  components: {
    Subpanel: () => import('Elements/Subpanel/Subpanel.vue'),
    Alert
  }
};
</script>

<style lang="scss" scoped>
.resume-list {
  padding: 24px;

  &__subpanel {
    margin-top: 16px;

    & > .tab__panel {
      height: 100%;
    }
  }

  & ::v-deep .el-tab-pane {
    height: inherit !important;
  }
}

.without-padding {
  padding: 0;
}
</style>
